import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import isExternalUrl from 'commons/isExternalUrl';
import PropTypes from 'prop-types';
const MainLink = t0 => {
  const $ = _c(3);
  const {
    name,
    url
  } = t0;
  let t1;
  if ($[0] !== name || $[1] !== url) {
    t1 = isExternalUrl(url) ? <a href={url} className="text-base leading-[25px] text-[#888] border-0 no-underline hover:text-[#484848] hover:transition-[opacity_.3s,transform_.3s] hover:![border-bottom:1px_solid_#484848] text-[1.2rem] font-bold">{name}</a> : <Link to={url} className="text-base leading-[25px] text-[#888] border-0 no-underline hover:text-[#484848] hover:transition-[opacity_.3s,transform_.3s] hover:![border-bottom:1px_solid_#484848] text-[1.2rem] font-bold">{name}</Link>;
    $[0] = name;
    $[1] = url;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
MainLink.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string
};
export default MainLink;